module.exports = __webpack_public_path__ + "img/50.e0968daa.png";